import { actions } from '@app/store/action/pending';

export default function (state = {}, action) {
  const { type } = action;

  switch (type) {
    case actions.PENDING_SET:
      if (state[action.id]) {
        return state;
      }
      state[action.id] = true;

      return {
        ...state,
      };

    case actions.PENDING_RESET:
      delete state[action.id];

      return {
        ...state,
      };
  }

  return state;
}
